import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import loginSchema from "../validation/loginSchema";
import { encryptData } from "../utils/encryptDecrypt";
import { authActions } from "../_store";
import LoginBg from "../assets/admin-bg.jpg";
import Logo from "../assets/logo/inmate-white-logo.png";
import { PasswordInput, TextInput } from "../components/common/ui/Inputs";
import Button from "../components/common/ui/Button";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";
import CustomLoader from "./../components/common/ui/Loader";
import { fetchWrapper } from "../_helpers";
import Swal from "sweetalert2";
import Marquee from "react-fast-marquee";
import useIPAddress from "../hooks/useIPAddress";
import useBrowserType from "../hooks/useBrowserType";

function Login() {
  const dispatch = useDispatch();
  const authUser = useSelector((x) => x.auth.user);
  const applicationMaintenance = useSelector((x) => x.auth.maintenanceText);
  const [loader, setLoader] = useState(false);
  const [loginForm, setLoginForm] = useState({
    UserName: "",
    plainPassword: "",
    UserPassword: "",
    BrowserType: "",
    IPAddress: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [submit, setSubmit] = useState(false);
  const [maintenanceScheduleText, setMaintenanceScheduleText] = useState("");
  const [isMaintenance, setIsMaintenance] = useState(false);
  const ip = useIPAddress();
  const browser = useBrowserType();
  // Load Application Maintence
  useEffect(() => {
    dispatch(authActions.LoadApplicationMaintence());
  }, [dispatch]);

  // Application Maintence Response
  useEffect(() => {
    if (applicationMaintenance) {
      if (applicationMaintenance.length > 0) {
        setIsMaintenance(true);
        setMaintenanceScheduleText(
          applicationMaintenance[0].MaintanenceAlert
        );
      } else {
        setIsMaintenance(false);
      }
    } else {
      setIsMaintenance(false);
    }
  }, [applicationMaintenance]);

  useEffect(() => {
    if (!authUser && !authUser?.IsLoginValid) return;
    switch (authUser?.IsLoginValid) {
      case -1:
        showToastNotification(
          "Something went wrong. Please try again",
          "warning"
        );
        setSubmit(false);
        dispatch(authActions?.logout());
        break;

      case -2:
        showToastNotification("Invalid Username or Password.", "warning");
        setSubmit(false);
        dispatch(authActions?.logout());
        break;

      case -3:
        showToastNotification(
          "Currently, this User is Inactive status",
          "warning"
        );
        setSubmit(false);
        dispatch(authActions?.logout());
        break;

      case -4:
        showToastNotification(
          "Invalid Username or Password",
          "warning"
        );
        setSubmit(false);
        dispatch(authActions?.logout());
        break;

      case -5:
        showToastNotification(
          "Invalid Username or Password",
          "warning"
        );
        setSubmit(false);
        dispatch(authActions?.logout());
        break;

      default:
        break;
    }
  }, [authUser]);


  // const handleChange = (e) => {
  //   const { name, value } = e?.target;
  // const regex = /^[a-zA-Z0-9\s]*$/;
  // if (!regex.test(value)) return;
  //   if (value.trim() === "" && value !== "") return;
  //   setLoginForm({ ...loginForm, [name]: value.trim() });
  // };

  const restrictCharacters = (e, restrictedChars = ["'", "`"]) => {
    if (restrictedChars.includes(e.key)) {
      e.preventDefault(); // Prevent the restricted character from being entered
    }
  };

  const handleChange = (e) => {
    const { name, value } = e?.target;
    if (name === "UserName") {
      const regex = /^[a-zA-Z0-9\s]*$/;
      if (!regex.test(value)) return;
      if (value.trim() === "" && value !== "") return;
      setLoginForm({ ...loginForm, [name]: value.trim() });
    }

    setLoginForm({ ...loginForm, [name]: value.trim() });
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = (e) => {
    e?.preventDefault();
    Swal.close();
    setSubmit(true);
    setErrorMessage({});
    if (document?.getElementsByClassName("input-error").length !== 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }
    const { error } = loginSchema(loginForm);
    if (error?.details) {
      setSubmit(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [e?.path.toString()]: e?.message,
        }));
        document
          .querySelector(`input[name=${path}]`)
          .classList.add("input-error");
      });
      return;
    }
    // showToastNotification("info", "Button clicked");
    const encryptPassword = encryptData(loginForm?.UserPassword);
    dispatch(
      authActions.login({
        UserName: loginForm?.UserName,
        UserPassword: encryptPassword,
        BrowserType: browser,
        IPAddress: ip,
      })
    )
      .then((result) => {
        if (!result?.payload) {
          setSubmit(false);
          showToastNotification("Something went wrong", "error");
        }
        setSubmit(false);
      })
      .catch((err) => {
        setSubmit(false);
        showToastNotification("Something went wrong", "error");
      });
  };


  const handleBlur = (e) => {
    const { name, value } = e.target;

    const updatedForm = { ...loginForm, [name]: value };

    const { error } = loginSchema(updatedForm);

    if (error?.details) {

      const fieldError = error.details.find((err) => err.path.includes(name));

      setErrorMessage((prev) => ({
        ...prev,
        [name]: fieldError ? fieldError.message : "",
      }));
    } else {
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  if (loader) {
    return <CustomLoader />;
  }
  return (
    <>
      <div id="app" className="app">
        <div className="login login-v2 fw-bold">
          <div className="login-cover">
            <div
              className="login-cover-img"
              style={{
                backgroundImage: `url(${LoginBg})`,
              }}
            ></div>
          </div>

          <div className="login-container">
            <div className="p-2 d-flex flex-wrap justify-content-center align-items-center">
              <img
                className="img-fluid mb-3"
                style={{ width: "180px", backgroundPosition: "center" }}
                src={Logo}
                alt="inmate-logo"
              />
            </div>
            <div
              className="login-card md-p-10 rounded-3"
              style={{ backgroundColor: "#ffffff" }}
            >
              {isMaintenance && (
                <>
                  {/* <marquee
              key={maintenanceScheduleText} 
                className="notification-batch-home maintenance-text mb-3"
                direction="left"
                scrollAmount="5"
                loop="-1"
                style={{
                  color: "#cf5c5c",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  display: "block",
                  width: "100%",
                }}
              >
                <span style={{ paddingRight: "50px" }}>{maintenanceScheduleText}</span>
              </marquee> */}
                  {maintenanceScheduleText?.trim()?.length > 0 && <Marquee
                    gradient={false}
                    speed={30}
                    pauseOnHover={true}
                    style={{ color: "#cf5c5c", backgroundColor: "#fee", fontSize: '15px', marginBottom: "1rem" }}
                  >
                    {maintenanceScheduleText + "                         "}
                  </Marquee>}
                  {/* <div className="marquee-container mb-3">
                <div className="marquee-content">
                  <span>{maintenanceScheduleText}</span>
                </div>
              </div> */}
                </>
              )}


              <div className="login-header">
                <div className="brand">
                  <div className="d-flex flex-wrap align-items-center justify-content-center">
                    <b className="fs-2 text-color font-bolder">
                      MANAGEMENT CONSOLE
                    </b>
                  </div>
                </div>
              </div>

              <div className="login-content">
                <form
                  method="GET"
                  onSubmit={(e) => {
                    handleLogin(e);
                  }}
                >
                  <div className="mb-2">
                    <TextInput
                      name="UserName"
                      label="Username"
                      value={loginForm?.UserName}
                      handleChange={handleChange}
                      placeholder="Username"
                      required={true}
                      errorMessage={errorMessage}
                      maxLength={50}
                      autoComplete="new-username"
                      handleBlur={handleBlur}
                    />
                  </div>
                  <div className="mb-2">
                    <PasswordInput
                      name="UserPassword"
                      id="Password"
                      label="Password"
                      onKeyDown={(e) => restrictCharacters(e)}
                      // value={loginForm?.UserPassword}
                      handleChange={handleChange}
                      placeholder="Password"
                      required={true}
                      errorMessage={errorMessage}
                      showPassword={showPassword}
                      togglePasswordVisibility={togglePasswordVisibility}
                      autoComplete="new-password"
                      maxlength={25}
                      handleBlur={handleBlur}
                    />
                  </div>
                  <Button
                    label="Login"
                    status="primary"
                    type="submit"
                    disabled={submit}
                    className={"w-100 mt-3 font-size-16"}
                  />
                </form>
              </div>
            </div>
          </div>
        </div>

        <Link
          className="btn btn-icon btn-circle btn-theme btn-scroll-to-top"
          data-toggle="scroll-to-top"
        >
          <i className="fa fa-angle-up"></i>
        </Link>
      </div>
    </>
  );
}

export default React.memo(Login);
